module.exports = __webpack_public_path__ + "img/semua_inbox.43636487.svg";